import { useState } from 'react';
import { useRouter } from 'next/router';
import AddCircleRounded from '@mui/icons-material/AddCircleRounded';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useSignUpModal } from 'components/SignUpModal';
import { UsernameModal } from 'components/UsernameModal';
import { trackClickSignupEvent } from 'lib/hooks/useEventTracking';
import { useTeams } from 'lib/contexts/teamsContext';
import { userIsPaidTeamMember } from 'lib/helpers';

interface Props {
  onClick: () => void;
}

export const AddCreditButton = ({ onClick }: Props) => {
  const currentUser = useCurrentUser();
  const router = useRouter();
  const teams = useTeams();

  const { showSignUpModal } = useSignUpModal();
  const [showDialog, setShowDialog] = useState(false);
  const API = useApi();

  const click = () => {
    if (!currentUser?.id) {
      trackClickSignupEvent(API, 'post-credits-add-credit');
      showSignUpModal('Please sign up or sign in to give credits');
      return;
    } if (!currentUser?.username && !userIsPaidTeamMember(currentUser, teams)) {
      setShowDialog(true);
      return;
    }
    onClick();
  };

  return (
    <>
      <button
        type="button"
        className="btn-primary"
        onClick={click}
      >
        <AddCircleRounded fontSize="small" />
        {' '}
        Give Credit
      </button>
      {showDialog
        && <UsernameModal saveLabel="SAVE" info="Please add a username to give credits." onCancel={() => setShowDialog(false)} onSave={() => router.reload()} />}
    </>
  );
};
